const sizes = {
  s: 12,
  m: 24,
  l: 48,
}

export interface HalfCheckedIconProps extends React.HTMLAttributes<HTMLOrSVGElement> {
  size: keyof typeof sizes
}

export function HalfCheckedIcon({ size, ...otherProps }: HalfCheckedIconProps) {
  return (
    <svg
      {...otherProps}
      aria-hidden="false"
      focusable="false"
      role="img"
      id="CheckCircleFilled-id"
      height={sizes[size]}
      viewBox="0 0 24 24"
    >
      <path d="M12 1.5A10.5 10.5 0 0 0 1.5 12 10.5 10.5 0 0 0 12 22.5 10.5 10.5 0 0 0 22.5 12 10.5 10.5 0 0 0 12 1.5zM12 3c4.967 0 9 4.033 9 9s-4.033 9-9 9V3z" />
      <title>HalfCheckedCircle-icon</title>
    </svg>
  )
}
